import { render, staticRenderFns } from "./TrashIcon.vue?vue&type=template&id=228a8004&"
import script from "./TrashIcon.vue?vue&type=script&lang=ts&"
export * from "./TrashIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TrashIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports